import { useState } from "react";
import { articles, guideSteps, type Article } from "@/mocks/comicData";

const articleBodies: Record<number, string[]> = {
  1: [
    "第一次接触漫画阅读，面对琳琅满目的平台，很容易不知从何下手。其实挑选漫画阅读软件并不复杂，只要围绕四个维度去比较，就能快速锁定最合适的那一款。",
    "其一是画质与排版。高清源、可自定义字号和翻页方向，会直接影响阅读舒适度；其二是更新速度与稳定性，追更中的作品能否第一时间更新、连载是否规范，决定了你是否需要频繁切换站点；其三是资源广度，国漫、日漫、韩漫、美漫的覆盖面是否均衡；最后是使用体验，包括界面是否清爽、缓存下载与夜间模式是否顺手。",
    "综合来看，二次元向读者可以优先考虑哔哩哔哩漫画，偏爱国漫独家IP的可选择腾讯动漫，喜欢竖屏条漫与社区互动的则更适合快看漫画。先用免费章节小成本试读，再决定长期主力平台，是最稳妥的做法。",
  ],
  2: [
    "近年来国漫佳作不断，玄幻、武侠、都市、悬疑等题材百花齐放。本期的热门国漫盘点，主要围绕头部平台的在更高分作品展开。",
    "从题材上看，玄幻热血类作品以其宏大的世界观与爽快的成长线拥有大量拥趸；武侠古风类则以东方美学的写意画风与江湖气韵见长，适合偏好传统审美的读者。此外，都市异能、国潮奇幻等新兴题材也在持续走高。",
    "挑选时可以关注作品的评分、更新频率与读者口碑，优先选择在稳定平台上持续更新的作品，追更体验更佳。也别忘了用免费章节试读前几话，确认画风和节奏是否合拍。",
  ],
  3: [
    "日漫体系庞大，从经典长篇到连载新番应有尽有。对于刚入坑的新读者，建议先由浅入深，从口碑稳定、节奏明快的作品开始。",
    "入坑路径大致可以分为三个层次：第一层是耳熟能详的经典长篇，适合建立对日漫的整体印象；第二层是近年话题度高的新番连载，可以同步感受追更的乐趣；第三层则可根据个人偏好深入冷门与精品向作品，探索更多可能性。",
    "在平台选择上，注重漫画库完整度与更新规范性的读者，可以关注以日漫为主的精品平台，也可以借助动画与漫画联动的入口补充追番体验，让动画、漫画互为延伸。",
  ],
  4: [
    "竖屏条漫改变了传统纸漫的阅读方式，以适配手机、节奏明快、随手可刷著称，尤其适合通勤与碎片时间。韩漫正是条漫发展最为成熟的代表之一。",
    "韩漫平台在内容上以恋爱、奇幻、悬疑等题材见长，画风精致、叙事利落，很多作品以『一口气读完』为卖点。竖屏阅读带来更沉浸的体验，也催生了独特的社区文化与讨论氛围。",
    "如果你厌倦了传统翻页节奏，想尝试更轻快的阅读方式，不妨从人气韩漫入手，感受条漫特有的分镜与信息密度，或许会发现一片新天地。",
  ],
  5: [
    "长期追更漫画，细节体验同样重要。这里整理几个常见的设置技巧，让阅读体验全面提升。",
    "首先是离线下载：主流平台都支持将已更新章节缓存到本地，适合地铁通勤或飞行途中阅读；其次是护眼模式与夜间主题，长时间阅读时可降低蓝光与亮度刺激，缓解眼部疲劳；最后是翻页方式与字号调节，按自己的阅读习惯自定义，沉浸感更强。",
    "善用订阅与更新提醒功能，把心仪的作品加入追更清单，就再也不会错过每一话的更新了。",
  ],
  6: [
    "一部优质漫画的稳定更新与高清画质，离不开创作者与平台的共同努力。支持正版，既是对创作者劳动的尊重，也是让作品能够长久连载下去的保障。",
    "正版平台会为作品提供规范的版权保护、稳定的更新节奏与更清晰的画质，读者也能获得更好的阅读与互动体验。识别可靠平台，可以从是否取得正式授权、是否提供合法下载与规范的分级提示等方面判断。",
    "作为理性的读者，把追更的热情转化为对正版内容的支持，才能让更多好故事被创作出来，也让我们热爱的漫画生态更加健康长久。",
  ],
};

function ArticleModal({ article, onClose }: { article: Article; onClose: () => void }) {
  const body = articleBodies[article.id] || [article.excerpt];
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-background-950/50 p-4 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-lg bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative h-52 w-full overflow-hidden">
          <img src={article.image} alt={`${article.title} 配图`} className="h-full w-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent"></div>
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/35"
            aria-label="关闭文章"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
          <span className="absolute bottom-3 left-5 inline-flex rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50">
            {article.category}
          </span>
        </div>
        <div className="p-6 md:p-8">
          <div className="flex items-center gap-3 text-sm text-foreground-500">
            <span>{article.date}</span>
            <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
            <span>阅读约 {article.readTime}</span>
          </div>
          <h3 className="mt-3 text-2xl font-semibold text-foreground-900">{article.title}</h3>
          <div className="mt-5 space-y-4">
            {body.map((p, i) => (
              <p key={i} className="leading-relaxed text-foreground-700">
                {p}
              </p>
            ))}
          </div>
          <div className="mt-6 flex items-center justify-between border-t border-background-200/70 pt-5">
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-800">#{article.tag}</span>
            <button
              type="button"
              onClick={onClose}
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 hover:bg-primary-600"
            >
              关闭阅读
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Guide() {
  const [active, setActive] = useState<Article | null>(null);

  return (
    <section id="guide" className="section-x py-14 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
          <span className="h-2 w-2 rounded-full bg-primary-500"></span>
          阅读攻略 · 追更指南
        </p>
        <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">从入门到熟练，轻松掌握漫画追更</h2>
        <p className="mt-3 text-foreground-600">通过四步选对平台，再参考深度攻略快速提升阅读体验。</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {guideSteps.map((step, i) => (
          <div
            key={step.title}
            className="relative rounded-lg border border-background-200/70 bg-background-100/60 p-5"
          >
            <span className="font-heading text-4xl text-primary-200">{String(i + 1).padStart(2, "0")}</span>
            <span className="mt-3 flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
              <i className={`${step.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 text-lg font-semibold text-foreground-900">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <button
            key={article.id}
            type="button"
            onClick={() => setActive(article)}
            className="group cursor-pointer overflow-hidden rounded-lg border border-background-200/70 bg-background-50 text-left transition-colors hover:border-primary-200"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={article.image}
                alt={`${article.title} 封面图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                {article.category}
              </span>
            </div>
            <div className="p-5">
              <h3 className="text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                {article.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                <span>{article.date}</span>
                <span className="inline-flex items-center gap-1 text-secondary-700">
                  阅读约 {article.readTime}
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>

      {active && <ArticleModal article={active} onClose={() => setActive(null)} />}
    </section>
  );
}